// @flow

import React, { type Node } from 'react';
import { Button } from '@tectonics/look-and-feel/uber/commons/atoms';

type Props = {
  href: string,
  children?: Node,
};

export function SaveAttachmentButton({ href, children, ...rest }: Props): Node {
  return (
    <Button {...rest} as="a" target="_blank" href={href} style={{letterSpacing:'0.035px'}} block>
      {children}
    </Button>
  );
}
